import { Spinner, Tooltip, Caption1 } from '@fluentui/react-components';
import {
  DocumentBulletList24Regular,
  ChevronRight20Regular
} from '@fluentui/react-icons';
import { useSelector, connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { MedicalInsuranceAgreementsPriceList } from '../../../models/Entities/MedicalInsuranceAgreements/MedicalInsuranceAgreementsPriceList';
import { AppState } from '../../../redux/reducers';

//styles
import './AgreementPriceList.css';

// functions
import * as ownFunctions from './AgreementPriceListFunctions';

export interface IProps {
  priceList: MedicalInsuranceAgreementsPriceList[];
  onSelectPriceList?: (PriceList: MedicalInsuranceAgreementsPriceList) => void;
}

export const AgreementsPriceListComponent = (props: IProps) => {
  const ListPriceState = useSelector((state: AppState) => state.PriceList);
  const [priceListSelected, setPriceListSelected] =
    useState<MedicalInsuranceAgreementsPriceList>();

  const [t] = useTranslation();

  const onSelectListHandler = (list: MedicalInsuranceAgreementsPriceList) => {
    setPriceListSelected(list);
    if (props.onSelectPriceList) props.onSelectPriceList(list);
  };

  if (ListPriceState?.isLoadingAll) {
    return (
      <div className="priceListCardList-loading">
        <Spinner size="medium" label={t('agreementsPriceList.loading')} />
      </div>
    );
  }

  if (!props.priceList || props.priceList.length === 0) {
    return (
      <div className="priceListCardList-empty">
        {t('agreementsPriceList.noPriceLists')}
      </div>
    );
  }

  return (
    <ul className="priceListCardList">
      {props.priceList.map((item) => {
        const isSelected = item.id === priceListSelected?.id;
        const status = ownFunctions.GetPriceListStatus(item);
        const statusLabel = t(status.i18nKey);

        return (
          <li key={item.id} style={{ listStyle: 'none' }}>
            <button
              type="button"
              onClick={() => onSelectListHandler(item)}
              className={`priceListCard${isSelected ? ' selected' : ''}`}
            >
              <div className="priceListCard-iconWrap">
                <DocumentBulletList24Regular />
              </div>
              <div className="priceListCard-body">
                <Tooltip
                  content={item.priceList.listName}
                  relationship="label"
                  withArrow
                >
                  <div className="priceListCard-title">
                    {item.priceList.listName}
                  </div>
                </Tooltip>
                <Caption1
                  className={`priceListTag pricelist ${status.status}`}
                >
                  {statusLabel}
                </Caption1>
              </div>
              <div className="priceListCard-chevron" aria-hidden="true">
                <ChevronRight20Regular />
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(AgreementsPriceListComponent as any);
